import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'
import {
  Box, DashboardModuleListItem, Image, Text,
} from '@domain-group/suit-theme'

import useSavedArtwork from '@hooks/useSavedArtwork'

import { SavedArtworkModel } from '@models/types'

import placeholderImageUrl from '../../../../../../assets/placeholder.svg'

type SavedArtworkListItemProps = {
  entity: SavedArtworkModel,
}

const SavedArtworkListItem = (props: SavedArtworkListItemProps) => {
  const { entity: savedArtwork } = props
  const { title: artworkTitle } = savedArtwork

  const savedArtworkPayload = useSavedArtwork({ id: savedArtwork.id })

  const {
    callbacks: { launchManageSavedArtworkModal },
    firstSavedArtworkPage,
    user,
  } = savedArtworkPayload

  const createdDateTime = digObject(savedArtwork, 'dates.created.date_time')
  const thumbUrl = digObject(firstSavedArtworkPage, 'previews.thumb', '')

  const createdDateTimeFormatted = DateTime.fromFormat(
    createdDateTime,
    'dd/MM/yyyy HH:mm',
  ).toFormat('h:mm a dd/MM/yyyy ')

  const artworkPageCount = savedArtwork.pages_count
  const pagesText = artworkPageCount === 1 ? '1 Page' : `${artworkPageCount} Pages`

  return (
    <DashboardModuleListItem
      imageComponent={(
        <Image
          backgroundSize="contain"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          forwardProps={{ backgroundColor: 'whiteGrey' }}
          placeholderUrl={placeholderImageUrl}
          url={thumbUrl}
        />
      )}
      onClick={() => launchManageSavedArtworkModal()}
      secondaryText={pagesText}
      // @ts-expect-error TS2322
      showAngleIcon
      title={artworkTitle}
    >
      <Box flexDirection="column" textAlign="right" fontSize="xsmall">
        {user.full_name && <Text marginBottom="small">{user.full_name}</Text>}

        <Text color="bodyFontLightColor">{createdDateTimeFormatted}</Text>
      </Box>
    </DashboardModuleListItem>
  )
}

export default SavedArtworkListItem
